import Resturent from './Components/Basics/Resturent'

const App = () => {
  return (
    <>
   
    <Resturent/>
    </>
  );
};


 
export default App;

 